import React from 'react';

const GPCIndicator = () => {
  const isGPCSignalDetected = typeof window !== 'undefined' && window?.navigator?.globalPrivacyControl;

  if (!isGPCSignalDetected) {
    return null;
  }

  return (
    <div className="sui-flex sui-justify-center sui-text-center sui-text-xs sui-items-center sui-mt-2 sui-gap-1">
      <svg width="6" height="6" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="4" cy="4" r="4" fill="#22c55e" />
      </svg>
      <p>GPC signal detected</p>
    </div>
  );
};

export { GPCIndicator };
